/** @format */

import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";

export const getMerchant = createAsyncThunk(
  "merchant/getMerchant",
  async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_V3_BASE_URL}/v1/api/cms/public/merchant`,
      {
        params: {
          page: 1,
          limit: 10,
          sort: "desc",
          by: "def.created_at_merchant",
          search: "",
        },
      },
    );
    console.log("respon merchant", response.data);
    return response.data.data;
  },
);

const merchantEntity = createEntityAdapter({
  selectId: (merchant) => merchant.id_merchant,
});

const merchantSlice = createSlice({
  name: "merchant",
  initialState: merchantEntity.getInitialState(),
  extraReducers: {
    [getMerchant.fulfilled]: (state, action) => {
      merchantEntity.setAll(state, action.payload);
    },
  },
});

export const merchantSelector = merchantEntity.getSelectors(
  (state) => state.merchant,
);
export default merchantSlice.reducer;
